export default __webpack_public_path__ + "static/media/about_us_img.5d23f711.jpg";